module.exports = __webpack_public_path__ + "img/wide.f3b69cc0.jpg";